import { http } from '@/services/http';

import type { InitializeChatResponse, SendMessageArgs } from '../types/chat.types';

export const BASE_PATH = 'go/chatbot/chat';

export async function initializeChat(): Promise<InitializeChatResponse> {
  const response = await http.internal.post(`${BASE_PATH}/initialize`);
  return response.data as InitializeChatResponse;
}

// Opens a streaming chat request and returns a reader
export async function openChatStream(
  params: SendMessageArgs,
  signal: AbortSignal
): Promise<ReadableStreamDefaultReader<Uint8Array> | null> {
  const { conversationId, message, userId } = params;
  const response = await http.internal.post(
    BASE_PATH,
    { conversation_id: conversationId, message, user_id: userId },
    { adapter: 'fetch', responseType: 'stream', signal: signal as any }
  );
  const reader = response.data?.getReader?.();
  return reader ?? null;
}
